module.exports = __webpack_public_path__ + "static/media/josh.5a0ac5c7.png";